// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"QP-z","upvoteIcon":"RP-z","downvoteIcon":"SP-z","feedbackIcon":"TP-z"};